import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";
import { ClientesService } from "../clientes/clientes.service";
import { FaturasService } from "../faturas/faturas.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

declare var swal, $: any;

@Component({
  selector: 'app-controle-financeiro',
  templateUrl: './controle-financeiro.component.html'
})
export class ControleFinanceiroComponent extends Components implements OnInit {

  formFiltro: FormGroup;
  filtro = {
    data_de: '',
    data_ate: '',
    id_cliente: ''
  };

  listClientes = [];
  relatorioData = [];
  carregando: boolean = false;
  pesquisado: boolean = false;

  constructor(
    formBuilder: FormBuilder,
    private clientesService: ClientesService,
    private faturasService: FaturasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    const date = new Date().toISOString();
    this.filtro.data_de = date.substr(0, 8) + '01'; // Primeiro dia do mês corrente
    this.filtro.data_ate = date.substr(0, 10);      // Data de hoje

    this.formFiltro = formBuilder.group({
      data_de: [this.filtro.data_de, [Validators.required]],
      data_ate: [this.filtro.data_ate, [Validators.required]],
      id_cliente: [this.filtro.id_cliente]
    });

    // Busca lista de clientes para o dropdown
    this.clientesService.get(null, null, ['id_cliente', 'nome_tratamento'])
      .subscribe(
        json => {
          this.listClientes = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        }
      );
  }

  ngOnInit() {
  }

  buscar() {
    if (!this.formFiltro.valid) {
      return;
    }

    this.carregando = true;
    this.pesquisado = true;
    this.relatorioData = [];

    this.faturasService.getControleFinanceiro(this.filtro.data_de, this.filtro.data_ate, this.filtro.id_cliente)
      .subscribe(
        json => {
          const rows = json.Payload || [];
          const colors = [
            '#FFF2CC', // Soft Yellow
            '#E2EFDA', // Soft Green
            '#DDEBF7', // Soft Blue
            '#FCE4D6', // Soft Orange
            '#E8D8F8', // Soft Purple
            '#F1E1E6', // Soft Pink
            '#E0F2F1', // Soft Teal
            '#EDEDED'  // Soft Gray
          ];
          let colorIndex = 0;
          let lastFatura = null;

          this.relatorioData = rows.map(row => {
            if (lastFatura !== null && row.fatura !== lastFatura) {
              colorIndex = (colorIndex + 1) % colors.length;
            }
            lastFatura = row.fatura;
            row.bgColor = colors[colorIndex];
            return row;
          });

          this.carregando = false;
        },
        error => {
          this.func.showErro(error.json());
          this.carregando = false;
        }
      );
  }

  formatDate(dateStr) {
    if (!dateStr) return '';
    const onlyDate = dateStr.split(' ')[0];
    const parts = onlyDate.split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`; // YYYY-MM-DD -> DD/MM/YYYY
    }
    return dateStr;
  }

  formatCurrency(value, currencyIso) {
    if (value === null || value === undefined) return '';
    const number = Number(value);
    const formatted = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (currencyIso || 'BRL') === 'USD' ? `US$ ${formatted}` : `R$ ${formatted}`;
  }

  exportToExcel() {
    if (this.relatorioData.length === 0) {
      swal(this.func.traduzir('front.erro'), "Nenhum dado encontrado para exportação.", "error");
      return;
    }

    let html = `
      <table border="1">
        <thead>
          <tr style="background-color: #f2f2f2; font-weight: bold;">
            <th>Cliente</th>
            <th>Data Inspeção</th>
            <th>Container</th>
            <th>Conhecimento/BL</th>
            <th>Valor</th>
            <th>Fatura</th>
            <th>Status</th>
            <th>Serviços Prestados</th>
            <th>Nota Fiscal</th>
            <th>Invoice</th>
          </tr>
        </thead>
        <tbody>
    `;

    for (let row of this.relatorioData) {
      html += `
        <tr style="background-color: ${row.bgColor};">
          <td>${row.cliente || ''}</td>
          <td>${this.formatDate(row.data)}</td>
          <td>${row.container || ''}</td>
          <td>${row.bl || ''}</td>
          <td>${this.formatCurrency(row.valor, row.moeda)}</td>
          <td>${row.fatura || ''}</td>
          <td>${row.status || ''}</td>
          <td>${row.servico || ''}</td>
          <td>${row.nota_fiscal || ''}</td>
          <td>${row.invoice || ''}</td>
        </tr>
      `;
    }

    html += '</tbody></table>';

    const header = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="utf-8"><!--[if gte mso 9]><xml><x:Workbook><x:Worksheets><x:Worksheet><x:Name>Controle Financeiro</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:Worksheet></x:Worksheets></x:Workbook></xml><![endif]--></head><body>`;
    const footer = `</body></html>`;

    const blob = new Blob([header + html + footer], { type: 'application/vnd.ms-excel;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Controle_Financeiro_${this.filtro.data_de}_a_${this.filtro.data_ate}.xls`;
    a.click();
  }

}



// WEBPACK FOOTER //
// ./src/app/financeiro/controle-financeiro.component.ts